import useSeo from '@/hooks/useSeo';
import Hero from '@/pages/home/components/Hero';
import HotToday from '@/pages/home/components/HotToday';
import PickedTimelines from '@/pages/home/components/PickedTimelines';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import MethodSection from '@/pages/home/components/MethodSection';
import TestimonialSection from '@/pages/home/components/TestimonialSection';
import FaqSection from '@/pages/home/components/FaqSection';
import { events } from '@/mocks/events';
import { faqs } from '@/mocks/faqs';
import { site } from '@/mocks/site';

const SITE_URL = 'https://captain2016.cn';

export default function Home() {
  useSeo({
    title: '蝌蚪吃瓜 — 娱乐事件时间线梳理与来龙去脉深度拆解',
    description:
      '蝌蚪吃瓜专注娱乐事件时间线梳理，按起点、发酵、回应、结局还原来龙去脉，做前因后果深度拆解。三条时间线看懂一件事，快速吃透每一个细节。',
    keywords: '蝌蚪吃瓜,蝌蚪吃瓜时间线,蝌蚪吃瓜来龙去脉,蝌蚪吃瓜前因后果,蝌蚪吃瓜深度拆解',
    path: '/',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: site.name,
        url: SITE_URL,
        description: site.intro,
        potentialAction: {
          '@type': 'SearchAction',
          target: `${SITE_URL}/timeline?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: site.name,
        url: SITE_URL,
        email: site.email,
        slogan: site.slogan,
      },
      {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: '蝌蚪吃瓜 精选事件时间线',
        itemListElement: events.slice(0, 6).map((item, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: item.title,
          url: `${SITE_URL}/timeline/${item.id}`,
        })),
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.answer,
          },
        })),
      },
    ],
  });

  return (
    <>
      <Hero />
      <HotToday />
      <PickedTimelines />
      <CategoryGrid />
      <MethodSection />
      <TestimonialSection />
      <FaqSection />
    </>
  );
}